import type { StepType } from "@reactour/tour";
import TourStepContent from "../../wrapper";
import { typeSomeText } from "../../common";
import { text, translateJadleToLocale } from "@quickpoint.me/shared";

const t = () => text.tourSteps;

const addImage: StepType[] = [
	{
		selector: "#action-control-files",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.teacherClickFiles}</span>}
			/>
		),
		action: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
		},
	},
	{
		selector: "#file-uploader",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherUploadDescription}
					</span>
				)}
			/>
		),
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{t().basicsTypePrefix} <strong>image:</strong> {text.tourSteps.teacherTypeImageSuffix}
					</span>
				)}
			/>
		),
		position: "left",
		action: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
			typeSomeText({
				text: translateJadleToLocale("\nimage:bauhaus"),
				prefill: translateJadleToLocale(`title: ${t().teacherFirstTitle}\n${t().teacherFirstParagraph}`),
			});
		},
	},
];

export default addImage;
